
    import {
        computed,
        defineComponent,
        unref,
    } from 'vue';
    import { DirectFlightFilter, BonusMilesFilter, MirCashbackFilter } from '@features/tourProduct/filterTourProducts';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import IsExclusiveFilter from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilter.vue';
    import useAdditionalFiltersHotel from '../common/useAdditionalFiltersHotel';
    import { PrepaymentsFilter } from '@features/firstPaymentDefinition/filterByPrepayments';

    export default defineComponent({
        name: 'AdditionalFiltersHotel',
        components: {
            Dropdown,
            IsExclusiveFilter,
            DirectFlightFilter,
            PrepaymentsFilter,
            BonusMilesFilter,
            MirCashbackFilter,
        },
        setup(props, ctx) {
            const {
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                isExclusiveChanged,
                directFlightChanged,
                bonusMilesChanged,
                mirCashbackChanged,
                isExclusiveSelected,
                directFlightSelected,
                bonusMilesSelected,
                mirCashbackSelected,
                directFlightFilterShow,
                isBonusMilesFilterVisible,
                isMirCashbackFilterVisible,
                additionalFiltersHidden,
                numOfSelected,
                selectedOperators,
                prepaymentFilterShow,
                uniquePrepaymentsList,
                prepaymentFilterChanged,
                prepaymentsSelected,
            } = useAdditionalFiltersHotel(ctx);

            const isAdditionalFilterVisible = computed(() => unref(isExclusiveFilterShow) || unref(directFlightFilterShow) || unref(prepaymentFilterShow) || unref(isBonusMilesFilterVisible) || unref(isMirCashbackFilterVisible));
            return {
                additionalFiltersHidden,
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                directFlightFilterShow,
                isExclusiveChanged,
                directFlightChanged,
                bonusMilesChanged,
                mirCashbackChanged,
                isExclusiveSelected,
                directFlightSelected,
                bonusMilesSelected,
                mirCashbackSelected,
                isAdditionalFilterVisible,
                isBonusMilesFilterVisible,
                isMirCashbackFilterVisible,
                numOfSelected,
                selectedOperators,
                prepaymentFilterShow,
                uniquePrepaymentsList,
                prepaymentFilterChanged,
                prepaymentsSelected,
            };
        },
    });
